import React, { useEffect, useState } from 'react';

type Props = {
    minValue?: number;
    maxValue?: number;
    onChange: (number: [number, number]) => void;
};

export default function FormGroupNumberRange({ minValue, maxValue, onChange }: Props) {
    const [min, setMin] = useState<string>('');
    const [max, setMax] = useState<string>('');

    useEffect(() => {
        setMin(minValue?.toString() ?? '');
        setMax(maxValue?.toString() ?? '');
    }, [minValue, maxValue]);

    function handleChange(newMin: string, newMax: string) {
        setMin(newMin);
        setMax(newMax);
        const minNumber = newMin === '' ? null : parseFloat(newMin);
        const maxNumber = newMax === '' ? null : parseFloat(newMax);

        // eslint-disable-next-line eqeqeq
        if (minValue == minNumber && maxValue == maxNumber) {
            return;
        }

        if (Number.isNaN(minNumber) || Number.isNaN(maxNumber)) {
            return;
        }

        onChange([minNumber, maxNumber]);
    }

    return (
        <div className="form-group d-inline-flex">
            <input
                type="search"
                className="form-control w-50"
                placeholder="min"
                value={min}
                onChange={(e) => handleChange(e.target.value, max)}
            />
            <input
                type="search"
                className="form-control w-50"
                placeholder="max"
                value={max}
                onChange={(e) => handleChange(min, e.target.value)}
            />
        </div>
    );
}
